import { HttpHeaders, HttpParams } from '@angular/common/http';
import { ApiService } from './api.service';
import { Injectable } from '@angular/core';
import { map } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class ConnectiveLoginService {
  constructor(private apiService: ApiService) { }

  connectiveLogin(erpToken: any, connected: boolean) {
    const url = '/auth/connect?erp_token=' + erpToken + '&connected=' + (connected ? 1 : 0);
    const appCode = 'vcontract';
    const appPass = 'VmpKMGFtVkdVWGxWYmxKVVlteGFWMWx0TVRSWlZscHhVVlJDYTJSNk1Eaw';
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept-Language': 'vi',
      Tenant: localStorage.getItem('tenantId') == null ? '' : localStorage.getItem('tenantId'),
      app_code: appCode,
      app_pass: appPass
    });
    const params = new HttpParams();
    return this.apiService.getHeaders(url, params, headers)
      .pipe(map(res => {
        return res;
      }));
  }

  erpToken(erpToken: any, domain: any){
    const url = '/auth/token?token=' + erpToken + '&domain=' + domain;
    const appCode = 'vcontract';
    const appPass = 'VmpKMGFtVkdVWGxWYmxKVVlteGFWMWx0TVRSWlZscHhVVlJDYTJSNk1Eaw';
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
      'Accept-Language': 'vi',
      app_code: appCode,
      app_pass: appPass
    });
    const params = new HttpParams();
    return this.apiService.getHeaders(url, params, headers)
    .pipe(map(res => {
      return res;
    }));
  }
}
